var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUzUzbekistan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_24560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 30H0V45H60V30Z",
    fill: "#1EB53A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V15H60V0Z",
    fill: "#0099B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 14.4004H0V30.6004H60V14.4004Z",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 15.2998H0V29.6998H60V15.2998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3998 12.5998C44.4175 12.5998 41.9998 10.1821 41.9998 7.19981C41.9998 4.21747 44.4175 1.7998 47.3998 1.7998C50.3821 1.7998 52.7998 4.21747 52.7998 7.19981C52.7998 10.1821 50.3821 12.5998 47.3998 12.5998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6 12.5998C42.6177 12.5998 40.2 10.1821 40.2 7.19981C40.2 4.21747 42.6177 1.7998 45.6 1.7998C48.5823 1.7998 51 4.21747 51 7.19981C51 10.1821 48.5823 12.5998 45.6 12.5998Z",
    fill: "#0099B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5223 10.4414L35.8643 11.4674L35.3423 11.6474",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_24560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUzUzbekistan);
export default __webpack_public_path__ + "static/media/uz Uzbekistan.3e9b1c6d35f4a40c52907412b6da2849.svg";
export { ForwardRef as ReactComponent };